import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class BaseService {
    private apiUrl = environment.apiEndpoint;

    constructor() { }

    public getUrl(path: string) {
        return `${this.apiUrl}${path}`;
    }
}
